<template>
  <div class="panel_shouyin">
    <div class="titleLine"></div>
    <div style="margin: 0px 10px">
      <el-table :data="dingjinOrder" style="width: 100%">
        <el-table-column label="单号">
          <template slot-scope="scope">
            {{ scope.row.no }}
          </template>
        </el-table-column>
        <el-table-column label="宠物">
          <template slot-scope="scope">
            {{ scope.row.order_item_list[0].goods_name }}
          </template>
        </el-table-column>
        <el-table-column label="品种">
          <template slot-scope="scope">
            {{ scope.row.order_item_list[0].category_info.name }}
          </template>
        </el-table-column>
        <el-table-column label="订金">
          <template slot-scope="scope">
            {{ scope.row.total_price }}
          </template>
        </el-table-column>
        <el-table-column label="创建时间">
          <template slot-scope="scope">
            {{ $public.FTime(scope.row.create_time) }}
          </template>
        </el-table-column>
        <el-table-column label="创建门店">
          <template slot-scope="scope">
            {{ $public.getShopNameById(scope.row.company_info.shop_id) }}
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="see(scope.row)">查看</el-button> -->
            <el-button type="text" @click="del(scope.row)">退订金</el-button>
            <el-button type="text" @click="update(scope.row)">付尾款</el-button>
            <el-button type="text" @click="add(scope.row)">加订金</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <xizaokaSee
      v-if="drawerSee_state"
      :curItem="curItem"
      @submit="submit_drawerSee"
    ></xizaokaSee>
    <!-- 结算 -->
    <div v-if="dialogSettlement_state">
      <dialogSettlement
        :type="dialogSettlement_type"
        :canYue="false"
        :orderId="curOrderId"
        @submit="submit_dialogSettlement"
      ></dialogSettlement>
    </div>
    <div v-show="drawerRemark_state">
      <drawerRemark
        :state="drawerRemark_state"
        :str="''"
        @submit="submit_drawerRemark"
      ></drawerRemark>
    </div>
    <div v-if="changeDingjinMoneyAdd_state">
      <changeDingjinMoneyAdd
        :row="curItem"
        @submit="submit_changeDingjinMoneyAdd"
      ></changeDingjinMoneyAdd>
    </div>
  </div>
</template>
<script>
import xizaokaSee from "../drawer/xizaokaSee.vue";
import dialogSettlement from "../../../../components/dialog_settlement.vue";
import drawerRemark from "../../../../components/drawer/drawer_remark.vue";
import changeDingjinMoneyAdd from "../drawer/changeDingjinMoneyAdd.vue";
export default {
  components: {
    xizaokaSee,
    dialogSettlement,
    drawerRemark,
    changeDingjinMoneyAdd,
  },
  data() {
    return {
      // see
      drawerSee_state: false,
      curItem: {},
      // del
      drawerRemark_state: false,
      // 结算
      dialogSettlement_type: "returnGoods",
      dialogSettlement_state: false,
      curOrderId: null,
      // 追加订金
      changeDingjinMoneyAdd_state: false,
    };
  },
  computed: {
    userInfo() {
      if (this.$store.state.mendian.userInfo._id) {
        return this.$store.state.mendian.userInfo;
      } else {
        return {
          basic_info: {},
          card_info: {},
          company_info: {},
          operation_info: {},
          pets_info: [],
          club_card: {},
        };
      }
    },
    curPetId() {
      return this.$store.state.mendian.curPetId;
    },
    curPetInfo() {
      return this.$store.getters["mendian/curPetInfo"];
    },
    dingjinOrder() {
      return this.$store.state.mendian.dingjinOrder;
    },
  },
  mounted() {},
  methods: {
    // 查看
    see(row) {
      this.drawerSee_state = true;
      this.curItem = row;
    },
    submit_drawerSee() {
      this.drawerSee_state = false;
    },
    // 删除
    del(row) {
      this.curItem = row;
      let params = {
        orderNumber: this.curItem._id,
      };
      let loading = this.$loading();
      this.$http
        .get("/api/ReturnOrder/Return/LivingAdvanceQuery", params)
        .then((res) => {
          loading.close();
          if (res.code == 0) {
            this.$confirm(
              "可退还 " + res.data.returnMoney + " 元。确定要退款？",
              "警告",
              {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning",
              }
            ).then(() => {
              this.drawerRemark_state = true;
            });
          }
        });
    },
    submit_drawerRemark(obj) {
      this.drawerRemark_state = false;
      if (obj.type === "success") {
        let params = {
          orderNo: this.curItem.no,
          remark: obj.data,
        };
        let loading = this.$loading();
        this.$http
          .post("/api/ReturnOrder/Return/LivingAdvance", params)
          .then((res) => {
            loading.close();
            if (res.code == 0) {
              this.curOrderId = res.data;
			  this.$message('退定金成功');
              return;
              // this.dialogSettlement_type = "returnGoods",
              // this.dialogSettlement_state = true;
            }
          });
      }
    },
    // 升级
    update(row) {
      this.curItem = row;
      this.$store.commit("livingUpdate/set_dingjinOrder", this.curItem);
      this.$store.commit("living/set_type", "update");
    },
    // 追加订金
    add(row) {
      this.curItem = row;
      this.changeDingjinMoneyAdd_state = true;
    },
    submit_changeDingjinMoneyAdd(obj) {
      this.changeDingjinMoneyAdd_state = false;
      if (obj.type === "success") {
        this.$http
          .post("/api/Order/AddToEarnestsOrder", obj.data)
          .then((res) => {
            if (res.code == 0) {
              this.curOrderId = res.data.no;
              (this.dialogSettlement_type = "order"),
                (this.dialogSettlement_state = true);
            }
          });
      }
    },
    // 结算
    submit_dialogSettlement(a) {
      this.dialogSettlement_state = false;
      if (a == "cancel") {
        console.log(a);
      } else if (a == "fail") {
        this.$message({
          message: "结算失败",
          type: "error",
        });
      } else if (a == "success") {
        this.$message({
          message: "结算成功",
          type: "success",
        });
        this.$store.dispatch("mendian/getUserInfo", this.userInfo._id);
      }
    },
  },
};
</script>
<style scoped lang="scss">
.panel_shouyin {
  height: 100%;
  background-color: #fff;
  padding: 0 0 20px;
  box-sizing: border-box;
  .titleLine {
    width: 100%;
    background-color: #fff;
    padding: 8px 8px 8px;
    box-sizing: border-box;
    margin-bottom: 4px;
  }
}
</style>
